module.exports = __webpack_public_path__ + "static/media/ban-do-hs-ts.14c8e491.png";